import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AdminLeadsApi from "./api/adminLeadsApi";
import { AdminLeadsState, LeadsQuery, LeadsQueryParameter } from "./models/AdminLeadsModels";

export const getLeads = createAsyncThunk(
  "adminLeads/getLeads",
  async (query: LeadsQuery) => {
    return AdminLeadsApi.getLeads(query);
  }
);

const initialState: AdminLeadsState = {
  query: {
    search: undefined,
    sortBy: LeadsQueryParameter.createdDate,
    sortDesc: true,
    pageNo: 1,
    pageSize: 20
  },
  leads: undefined,
  loading: false,
  success: undefined,
  error: undefined
};

const adminLeadsSlice = createSlice({
  name: "adminLeads",
  initialState: initialState,
  reducers: {
    changeQuery: (state, action) => {
      state.query = action.payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getLeads.pending, (state) => {
        state.loading = true;
      })
      .addCase(getLeads.fulfilled, (state, { payload }) => {
        state.leads = payload;
        state.loading = false;
      })
      .addCase(getLeads.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });
  }
});

export const {
  changeQuery,
  setSuccess
} = adminLeadsSlice.actions;

export default adminLeadsSlice.reducer;